import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Shared tab bar for the HR Payroll section, same pattern as CashFlowTabs.
const TABS = [
  { to: '/payroll/dashboard', label: 'Dashboard' },
  { to: '/payroll/employees', label: 'Employee Master' },
  { to: '/payroll/runs', label: 'Payroll Runs' },
];

const PayrollTabs = () => {
  const location = useLocation();
  return (
    <div className="glass-widget flex gap-1 p-1.5 mb-6 w-fit flex-wrap">
      {TABS.map((tab) => {
        const active = tab.to === '/payroll/runs'
          ? location.pathname.startsWith('/payroll/runs')
          : location.pathname === tab.to;
        return (
          <Link
            key={tab.to}
            to={tab.to}
            className={`text-sm px-4 py-1.5 rounded-xl font-medium transition-colors ${
              active ? 'bg-white/90 text-komal-blue' : 'text-white/85 hover:bg-white/10'
            }`}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
};

export default PayrollTabs;
